export const MIN_AGE = 18;

export const LOCALSTORAGE_USER_DATA = 'userData';
export const LOCALSTORAGE_PERSONIFIED_USER = 'personifiedUser';
export const LOCALSTORAGE_TOKEN_DATA = 'tokenData';
export const LOCALSTORAGE_LANGUAGE = 'language';
export const LOCALSTORAGE_CODE_VERIFIER = 'codeVerifier';
export const LOCALSTORAGE_CURRENT_SITE_ID = 'currentSite';
export const LOCALSTORAGE_RETURN_URL = 'returnUrl';
export const LOCALSTORAGE_TECHNICIAN_ID = 'technicianId';
export const LOCALSTORAGE_NOTIFICATION_MAINTENANCE_ID = 'notificationMaintenanceId';
export const LOCALSTORAGE_BETA_FE = 'betaFE';

export const APPLICATION_ID = 'frontend';
export const PRIVACY_APPLICATION_ID = 'fe-privacy';

export const USERNAME_REGEXP = '^[a-zA-Z0-9\.@\-_]{5,15}$';
export const PASSWORD_REGEXP = '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9@!$%&]{8,64}$';
export const PHONE_REGEXP = '^[0-9\-\+]{5,64}$';

export const ROUTE_IMPERS_DEFAULT = ['/impers', 'sites'];
export const ROUTE_USER_DEFAULT = ['/home', 'sites'];
export const ROUTE_TECHNICIAN_DEFAULT = ['/technician', 'support'];
export const ROUTE_SERVICE_DEFAULT = ['/came-service', 'keycodes'];
export const ROUTE_SUBSIDIARY_DEFAULT = ['/came-subsidiary', 'keycodes'];
export const ROUTE_DEFAULT = ['/home', 'sites'];
export const ROUTE_MARKETING_DEFAULT = ['/came-marketing', 'helperController'];


export const THEME_CAME_CLASSIC_NAME = 'came-classic';
export const THEME_CAME_CLASSIC_CSS = 'came';
export const THEME_CAME_NEW_NAME = 'came-new';
export const THEME_CAME_NEW_CSS = 'dim';